// extracted by mini-css-extract-plugin
module.exports = {"addToCartButton":"_1bqUf","disabled":"el9DK"};